import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { SubscriptionDetailPage } from '@/features/subscriptions'

export const Route = createFileRoute('/_authenticated/subscriptions/$subsId')({
  component: () => (
    <RequirePermission permission='subscriptions.read'>
      <SubscriptionDetailPage />
    </RequirePermission>
  ),
})
